import { CentricTypography as Typography } from '@core/component/CentricTypography'
import formatNumberByLocale from '@utils/format-number-by-locale'
import isNumber from 'lodash/isNumber'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { makeStyles } from '@material-ui/core'

interface IEnhancedBookQtyTotals {
  bookedCells: any
  isReset?: boolean
}

const useStyles = makeStyles(theme => ({
  totalActualQty: {
    padding: 10,
    width: '148px',
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.background.default,
    borderBottom: '1px solid #EEEEEE',
    borderTop: '1px solid #EEEEEE'
  },
  totalActualContainer: {
    width: 129,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  totalLabel: {
    paddingBottom: 2
  }
}))

const EnhancedBookQtyTotals: FC<IEnhancedBookQtyTotals> = ({ bookedCells, isReset }) =>
  useObserver(function useHook() {
    const classes = useStyles()

    return (
      <div className={classes.totalActualQty}>
        <div className={classes.totalActualContainer}>
          {(isNumber(bookedCells?.cell1?.cellValue) || isReset) && (
            <>
              <div className={classes.totalLabel}>
                <Typography variant={'body2'}>{bookedCells.cell1.cellLabel}</Typography>
              </div>
              <div>
                <Typography variant={'h6DarkGrey'}>
                  {`${bookedCells.cell1.cellCurrency}${formatNumberByLocale(
                    isReset ? 0 : bookedCells.cell1.cellValue
                  )}`}
                </Typography>
              </div>
            </>
          )}
        </div>
      </div>
    )
  })

export default memo(EnhancedBookQtyTotals)
